import { Component, ViewChild } from '@angular/core';
import { CoachingSessionTypeDTO } from '../../dtos/coaching-session.dto';
import {
  getSessionTypeLayoutDescription,
  getSessionTypeLayoutInfo,
  getSessionTypeLayoutLabel,
  getSessionTypeLayoutThumbnail,
  SessionTypeLayoutInfo,
} from '../../helpers/session-type/session-type-layout.constants';
import { ModalComponent, ModalConfig } from '../modals/modal/modal.component';

// Previews the LAYOUT a session type uses, not that type's own custom name/
// description — matches the confirmed Figma Make prototype (LogPreviewModal),
// which shows the layout's own label/thumbnail/description regardless of which
// specific session type row was clicked. No API call — the parent already has
// this row's data, this modal just re-derives layout info from it.
@Component({
  selector: 'app-session-type-preview-modal',
  templateUrl: './session-type-preview-modal.component.html',
  styleUrls: ['./session-type-preview-modal.component.scss'],
  standalone: false,
})
export class SessionTypePreviewModalComponent {
  @ViewChild('internalModal')
  internalModal: ModalComponent;

  sessionType: CoachingSessionTypeDTO;

  modalConfig: ModalConfig = {
    titleText: '',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    bodyClass: ['session-type-preview-modal-body'],
    customFooter: true,
  };

  open(sessionType: CoachingSessionTypeDTO): void {
    this.sessionType = sessionType;
    this.modalConfig.titleText = getSessionTypeLayoutLabel(sessionType);
    this.internalModal.loadConfig();
    this.internalModal.open();
  }

  closeModal(): void {
    this.internalModal.close();
  }

  get layoutDescription(): string | undefined {
    return this.sessionType
      ? getSessionTypeLayoutDescription(this.sessionType)
      : undefined;
  }

  get info(): SessionTypeLayoutInfo | undefined {
    return this.sessionType
      ? getSessionTypeLayoutInfo(this.sessionType)
      : undefined;
  }

  get thumbnailUrl(): string | undefined {
    return this.sessionType
      ? getSessionTypeLayoutThumbnail(this.sessionType)
      : undefined;
  }
}
